// Image Protection Utility
// Disables right-click, context menu, and long-press on images

export const initializeImageProtection = () => {
  // Disable right-click on images
  document.addEventListener('contextmenu', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  }, true);

  // Disable long-press (touch) on images - prevent "Save Image" on mobile
  document.addEventListener('touchstart', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
    }
  }, { passive: false });

  // Disable long-press context menu
  document.addEventListener('touchend', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
    }
  }, { passive: false });

  // Disable drag on images
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  }, true);

  // Disable image selection
  const style = document.createElement('style');
  style.textContent = `
    img {
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -o-user-select: none;
      user-select: none;
      -webkit-touch-callout: none;
      pointer-events: none;
    }
    
    img[alt],
    img[src] {
      -webkit-user-drag: none;
    }
  `;
  document.head.appendChild(style);

  // Prevent inspect element by disabling developer tools shortcut
  document.addEventListener('keydown', (e) => {
    // F12
    if (e.key === 'F12') {
      e.preventDefault();
      return false;
    }
    // Ctrl+Shift+I (Windows/Linux)
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      e.preventDefault();
      return false;
    }
    // Cmd+Option+I (Mac)
    if (e.metaKey && e.altKey && e.key === 'I') {
      e.preventDefault();
      return false;
    }
    // Ctrl+Shift+C (Windows/Linux - Inspect Element)
    if (e.ctrlKey && e.shiftKey && e.key === 'C') {
      e.preventDefault();
      return false;
    }
  });
};

export const removeImageProtection = () => {
  // Clean up if needed when component unmounts
  // Most protections are global, so this may not be necessary
  console.log('Image protection disabled');
};